import { useEffect } from "preact/hooks";
import type { Role } from "../guide.js";
import { Icon, type IconName } from "./icons.js";

export interface RoleShiftProps {
  readonly role: Role;
  readonly text: string;
  onDone(): void;
}

const ROLE_ICON: Record<Role, IconName> = {
  cerimonial: "grid",
  guest: "camera",
  wall: "monitor",
  client: "images",
};

export function RoleShift({ role, text, onDone }: RoleShiftProps) {
  useEffect(() => {
    const timer = setTimeout(onDone, 1500);
    return () => clearTimeout(timer);
  }, [text]);
  return (
    <button type="button" class="d-role-shift is-card" data-testid="role-shift" onClick={onDone}>
      <span class="d-role-shift-card" data-theme="dark">
        <Icon name={ROLE_ICON[role]} size={28} />
        <span>{text}</span>
      </span>
    </button>
  );
}
